import { ACCENT } from "@/lib/siteTheme";

interface EyebrowProps {
  children: React.ReactNode;
  dark?: boolean;
  className?: string;
}

const Eyebrow = ({ children, dark = false, className = "" }: EyebrowProps) => (
  <div className={`flex flex-col-reverse items-start gap-3.5 mb-6 ${className}`}>
    <span className="w-8 h-[3px] rounded-sm inline-block" style={{ background: ACCENT }} />
    <span
      className="font-bold text-[13px] tracking-[0.16em] uppercase"
      style={{ color: dark ? "rgba(247,243,236,0.7)" : "#9c5e15" }}
    >
      {children}
    </span>
  </div>
);

export default Eyebrow;
